<template>
  <div class="form-group">
    <h3>Step {{ currentStep }}. {{ config?.org_label || "Organization" }} Trip Protection</h3>
    <div class="infomsg">The {{ config?.org_label || "Organization" }} Trip Protection plans can insure your flight costs, too! These policies will come directly from {{ config?.org_label || "the organization" }} and are not affiliated with Flightfox.</div>

    <h4>Please select one of the following options for your quote:</h4>

    <div class="form-row">
      <div class="radiolabel" :class="{ on: modelValue === 'Already Selected' }" @click="$emit('update:modelValue', 'Already Selected')">
        <div class="radio" />
        <label>
          <p>I have already selected a trip insurance policy through {{ config?.org_label || "the organization" }} and would like to increase coverage for my flights</p>
        </label>
      </div>
    </div>

    <div class="form-row">
      <div class="radiolabel" :class="{ on: modelValue === 'Undecided' }" @click="$emit('update:modelValue', 'Undecided')">
        <div class="radio" />
        <label>
          <p>I am unsure and would like a quote on the cost to insure my flight.</p>
        </label>
      </div>
    </div>

    <div class="form-row">
      <div class="radiolabel" :class="{ on: modelValue === 'Not Interested' }" @click="$emit('update:modelValue', 'Not Interested')">
        <div class="radio" />
        <label>
          <p>I am not interested in adding insurance to cover my flight costs at this time.</p>
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  config: {
    type: Object,
    required: true,
  },
  currentStep: {
    type: Number,
    required: true,
  },
  modelValue: {
    type: String,
    default: null,
  },
});

defineEmits(["update:modelValue"]);
</script>
